import { generateActions } from "../generators/generator.actions";
export var APPLICATION_FILTERS_SLICE_NAME = "applicationFilters";
export var APPLICATION_FILTERS_ACTIONS = generateActions({
    entity: "ApplicationFilter",
    reducerKey: APPLICATION_FILTERS_SLICE_NAME,
    basePathEntity: "application-filters",
});
export var createApplicationFilterStart = APPLICATION_FILTERS_ACTIONS.createStart, updateApplicationFilterStart = APPLICATION_FILTERS_ACTIONS.updateStart, deleteApplicationFilterStart = APPLICATION_FILTERS_ACTIONS.removeStart;
